var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-warning"},[_vm._v(" Please keep in mind that these dates are in your current timezone, "),_c('strong',[_vm._v("which is not necessarily CET.")]),_vm._v(" For example, if you are in Moscow and you set the date as 25th of November 2018 00:00, it'd be 24th of November 2018 22:00 CET. ")])
}]

export { render, staticRenderFns }